import { render } from "./Import.vue?vue&type=template&id=2bba9f75"
import script from "./Import.vue?vue&type=script&lang=js"
export * from "./Import.vue?vue&type=script&lang=js"
script.render = render

export default script